import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckParametersFilter } from '@api/hitoryCheck';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_PARAMETER_FILTER } from '@constants/queryKeys';

export const useQueryHistoryCheckParametersFilter = (comparisonId: string) => {
	const { data: parameterFilterOptions } = useQuery<string[], TSelectOption[]>({
		queryKey: [HISTORY_CHECK_PARAMETER_FILTER, comparisonId],
		queryFn: extractQueryParams(getHistoryCheckParametersFilter),
		select: (options) => fieldsOptionsFormatted(options || []),
		enabled: [!!comparisonId],
		...refetchOptions,
	});

	return {
		parameterFilterOptions: parameterFilterOptions || [],
	};
};
